import { useContext, useState } from 'react';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';
import { useEffect } from 'react';


export function InventorySupplyModal({ setShowSupplyModal, getData, item }) {
  const {logOutFunction, userProfile} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const [formFields, setFormFields] = useState({ item_id: item?.product_id });

  const handleSubmit = async () => {
    const formData = new FormData();
    Object.entries(formFields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    formData.append('quantity', JSON.stringify(formFields?.quantity));
    setLoading(true)
    try {
        const response = await axios.post(base_url + '/add-inventory-item.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                accountid: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.code == 403) {
            logOutFunction()
        }
        if (response.data.status) {
            setTostMessage({
                messageType: 'success',
                message: response.data.message
            })
            getData();
            setShowSupplyModal(false);
        } else {
        setTostMessage({
            messageType: 'error',
            message: response.data.message
        })
        }
        setLoading(false)
    } catch (error) {
        setLoading(false)
        setTostMessage({
            messageType: 'error',
            message: 'Network Error'
        })
    }
  };

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div className='w-[80%] flex justify-end text-underline text-[#ff0000]'>
                    <p className='cursor-pointer' onClick={() => setShowSupplyModal(false)}>Cancel</p>
                </div>
                <a className='text-dark text-[17px] font-bold'>Add Inventory Supply</a>
                <a className='text-dark text-[15px] font-semibold'>{item?.product_name}</a>
                    <div className="w-[80%] mx-auto flex flex-col mt-2">
                        <label>Location</label>
                        <select
                            className="w-full mx-auto border p-2 rounded my-2"
                            onChange={(e) => setFormFields({...formFields, location_id: e.target.value})}
                        >
                            <option value="">Choose Locations</option>
                            {cookies?.userProfile?.locations?.map((item, index) => 
                                <option key={index} value={item.location_id}>{item.name}</option>
                            )}
                        </select>
                    </div>
                  {/* <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label>Quantity</label>
                    <input type='number' onChange={(e) => setFormFields({...formFields, quantity: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Supply Quantity" />
                  </div> */}
                  {/* <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label>Cost Price</label>
                    <input type='number' onChange={(e) => setFormFields({...formFields, cost_price: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Per Unit" />
                  </div> */}
                  <div className='w-auto self-start ml-[10%] flex flex-col mt-2 gap-y-1'>
                    <label>Quantity</label>
                    {item?.extras?.map((extra, index) => 
                        <div className='px-3 my-1 flex flex-col items-start justify-between'>
                            <label className='text-[#222222]'>{extra?.option}:</label>
                            <div className='flex flex-row justify-between items-center gap-x-2 w-full mb-1'>
                            <label className='text-[#222222] text-sm font-medium'>{'NGN'}</label>
                            <input type='number' className="w-auto border px-2 py-1 rounded text-sm md:text-[15px]" placeholder="Cost Price" 
                            value={
                                formFields.quantity?.find(q => q.option_id === extra.option_id)?.cost_price
                            }
                            onChange={(e) => {
                                const val = Number(e.target.value);

                                setFormFields(prev => {
                                const existing = prev.quantity || [];
                                const index = existing.findIndex(q => q.option_id === extra.option_id);

                                let updated;

                                if (index >= 0) {
                                    // update existing
                                    updated = [...existing];
                                    updated[index] = { ...updated[index], cost_price: val };
                                } else {
                                    // add new
                                    updated = [...existing, { option_id: extra.option_id, cost_price: val }];
                                }

                                return { ...prev, quantity: updated };
                                });
                            }}
                            />
                            </div>
                            <div className='flex flex-row justify-between items-center gap-x-2 w-full'>
                            <label className='text-[#222222] text-sm font-medium'>{'Unit(s)'}</label>
                            <input type='number' className="w-auto border px-2 py-1 rounded text-sm md:text-[15px]" placeholder="Supply Quantity" 
                            value={
                                formFields.quantity?.find(q => q.option_id === extra.option_id)?.qty
                            }
                            onChange={(e) => {
                                const val = Number(e.target.value);

                                setFormFields(prev => {
                                const existing = prev.quantity || [];
                                const index = existing.findIndex(q => q.option_id === extra.option_id);

                                let updated;

                                if (index >= 0) {
                                    // update existing
                                    updated = [...existing];
                                    updated[index] = { ...updated[index], qty: val };
                                } else {
                                    // add new
                                    updated = [...existing, { option_id: extra.option_id, qty: val }];
                                }

                                return { ...prev, quantity: updated };
                                });
                            }}
                            />
                            </div>
                        </div>
                    )}
                  </div>
                  
                  <div className="flex justify-between mt-5">
                        <button
                            onClick={handleSubmit}
                            className="
                            bg-[#037684] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Add Supply
                        </button>
                    </div>
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

